module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored@2x-e7b696d743a342d67a4a4450812dbde7.png";